import { Module } from 'wrapper6'

const $ = jQuery

export default class ProductDescriptions extends Module {
  ready (app) {
    const TITLES = document.querySelectorAll('.post-type-archive-product .woocommerce-loop-product__title.has-descriptions')
    const mobileReadMore = document.querySelectorAll('.post-type-archive-product .read-more')

    if (TITLES) {
      for (let i = 0; i < TITLES.length; i++) {
        const TITLE = TITLES[i]

        TITLE.addEventListener('click', () => {
          TITLE.classList.toggle('rotate')
          TITLE.parentElement.classList.toggle('show-descriptions')
        })
      }
    }

    if (mobileReadMore) {
      for (let i = 0; i < mobileReadMore.length; i++) {
        const readMore = mobileReadMore[i]

        readMore.addEventListener('click', () => {
          readMore.parentElement.querySelector('h2').classList.toggle('rotate')
          readMore.parentElement.classList.toggle('show-descriptions')
        })
      }
    }
  }
}
